import * as React from 'react';
import { IItem } from '../../../slices/inventorySlice';
import useTranslator from '../../../hooks/translate';
import { getItemDisplayName, getItemNameColor } from '../../../util/itemPresentation';

export const NameInfo: React.FC<{ item: IItem }> = ({ item }) => {
  const t = useTranslator();
  return <div style={{ color: getItemNameColor(item), textAlign: 'center' }}>{getItemDisplayName(item, t)}</div>;
};
